<template>
  <div id="app">
    <h2 style="text-align: center">お申し込みフォーム</h2>

    <el-row type="flex" justify="center">
      <el-col :span="12">

        <el-form ref="form" :model="doctor" label-width="120px">

          <el-form-item>
            <el-button type="primary" @click="onModification" style="width: 130px;float: right">個人情報更新</el-button>
          </el-form-item>

          <el-form-item label="メールアドレス" prop="email">
            <el-input v-model.trim="doctor.email" placeholder="tokyo@itiro.com"></el-input>
          </el-form-item>

          <el-form-item label="パスワード" prop="password">
            <el-input v-model.trim="doctor.password" placeholder="6文字以上半角英数字を設定してください" show-password></el-input>
          </el-form-item>

          <el-divider/>

          <el-form-item label="お名前" prop="name">
            <el-input v-model="doctor.name" placeholder="東京　一郎"></el-input>
          </el-form-item>

          <el-form-item label="お名前カナ" prop="kana">
            <el-input v-model="doctor.kana" placeholder="トウキョウ　イチロウ"></el-input>
          </el-form-item>

          <el-form-item label="性別" prop="gender">
            <el-radio v-model="doctor.gender" label="男">男</el-radio>
            <el-radio v-model="doctor.gender" label="女">女</el-radio>
          </el-form-item>

          <el-form-item label="生年月日" prop="birthday">
            <el-input v-model.trim="doctor.birthday" placeholder="1980-01-01"></el-input>
          </el-form-item>

          <el-form-item label="電話番号" prop="tel">
            <el-input v-model.trim="doctor.tel" placeholder="080-1234-5678"></el-input>
          </el-form-item>

          <el-form-item label="医籍登録番号" prop="medicalNumber">
            <el-input v-model.trim="doctor.medicalNumber" placeholder="TESTC99999"></el-input>
          </el-form-item>

          <el-form-item label="医療機関名" prop="medicalName">
            <el-input v-model="doctor.medicalName" placeholder="のぞみクリニック"></el-input>
          </el-form-item>

          <el-form-item label="医療機関名カナ" prop="medicalKana">
            <el-input v-model="doctor.medicalKana"　placeholder="ノゾミクリニック"></el-input>
          </el-form-item>

          <el-form-item label="医療機関住所">
            <el-form-item label="郵便番号" style="margin-bottom: 10px" prop="medicalPost">
              <el-input v-model.trim="doctor.medicalPost" placeholder="152-0004"></el-input>
            </el-form-item>
            <el-form-item label="都道府県" style="margin-bottom: 10px" prop="medicalPrefecture">
              <el-input v-model.trim="doctor.medicalPrefecture" placeholder="東京都"></el-input>
            </el-form-item>
            <el-form-item label="市区町村" style="margin-bottom: 10px" prop="medicalMunicipality">
              <el-input v-model.trim="doctor.medicalMunicipality" placeholder="目黒区"></el-input>
            </el-form-item>
            <el-form-item label="番地" prop="medicalAddress">
              <el-input v-model.trim="doctor.medicalAddress" placeholder="鷹番３-１-５グリーンアース　２階"></el-input>
            </el-form-item>
          </el-form-item>

          <el-form-item label="専門分野" prop="profession">
            <el-input type="textarea" v-model="doctor.profession" :autosize="{ minRows: 4, maxRows: 8}"></el-input>
          </el-form-item>

          <el-divider></el-divider>

          <el-form-item label="謝金のお振込先" prop="remittanceDestination">
            <el-input v-model.trim="doctor.remittanceDestination"></el-input>
          </el-form-item>

          <el-form-item label="金融機関名" prop="financialInstitutionName">
            <el-input v-model="doctor.financialInstitutionName"></el-input>
          </el-form-item>

          <el-form-item label="支店名" prop="bankBranchName">
            <el-input v-model="doctor.bankBranchName"></el-input>
          </el-form-item>

          <el-form-item label="預金種類" prop="depositType">
            <el-radio v-model="doctor.depositType" label="普通">普通</el-radio>
            <el-radio v-model="doctor.depositType" label="当座">当座</el-radio>
          </el-form-item>

          <el-form-item label="口座番号" prop="accountNumber">
            <el-input v-model.trim="doctor.accountNumber"></el-input>
          </el-form-item>

          <el-form-item label="口座名義人" prop="accountHolder">
            <el-input v-model="doctor.accountHolder"></el-input>
          </el-form-item>

          <el-form-item>
            <el-alert description="個人情報について、皆様からお預かりした個人情報は、利用目的以外には使用しません。" type="info" :closable="false"/>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit" style="width: 130px">送信</el-button>
            <el-button @click="onReturn" style="width: 130px">トップページへ</el-button>
          </el-form-item>

        </el-form>

      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Register",
  methods: {
    onSubmit() {
      if (this.dbAccounts.indexOf(this.doctor.email) !== -1) {
        this.$message({
          message: 'メールアドレスが既に登録しました',
          type: "error"
        })
        return
      }
      this.$confirm('このデータを送信しますか?', {
        confirmButtonText: '確定',
        confirmButtonClass: 'btn-confirm',
        cancelButtonText: 'キャンセル',
        cancelButtonClass: "btn-cancel",
        type: 'warning',
        roundButton: true
      }).then(() => {
        axios.post(`${this.GLOBAL.host}/rapha99Doctor/insert`, this.doctor).then(() => {
          this.$message({
            type: "success",
            message: '送信しました'
          })
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '送信をキャンセルしました'
        })
      })
    },
    onReturn() {
      // this.$router.push('/manager')
      window.location.href = "http://hope-medical.jp/"
    },
    onModification() {
      this.$router.push("/login")
    }
  },
  created() {
    axios.get(`${this.GLOBAL.host}/rapha99Doctor/getAll`).then(resp => {
      this.dbDoctors = resp.data
      this.dbAccounts = resp.data.map(doctor => doctor.email)
    })
  },
  data() {
    return {
      dbDoctors: null,
      dbAccounts: null,
      doctor: {
        name: null,
        kana: null,
        gender: null,
        birthday: null,
        email: null,
        tel: null,
        medicalNumber: null,
        medicalName: null,
        medicalKana: null,
        medicalPost: null,
        medicalPrefecture: null,
        medicalMunicipality: null,
        medicalAddress: null,
        profession: null,

        remittanceDestination: null,
        financialInstitutionName: null,
        bankBranchName: null,
        depositType: null,
        accountNumber: null,
        accountHolder: null
      },
      // rules: {
      //   name: [{required: true, trigger: 'blur'}],
      //   kana: [{required: true, trigger: 'blur'}],
      //   gender: [{required: true, trigger: 'blur'}],
      //   birthday: [{required: true, trigger: 'blur'}],
      //   email: [{required: true, trigger: 'blur'}],
      //   tel: [{required: true, trigger: 'blur'}],
      //   medicalNumber: [{required: true, trigger: 'blur'}],
      //   medicalKana: [{required: true, trigger: 'blur'}],
      //   medicalPost: [{required: true, trigger: 'blur'}],
      //   medicalPrefecture: [{required: true, trigger: 'blur'}],
      //   medicalMunicipality: [{required: true, trigger: 'blur'}],
      //   medicalAddress: [{required: true, trigger: 'blur'}],
      //   profession: [{required: true, trigger: 'blur'}],
      // }
    }
  },
}
</script>

<style>
.btn-cancel {
  width: 100px;
  float: right;
}
.btn-confirm {
  width: 100px;
}
</style>